export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_GRAPHIC_DESIGN.4d31968f.svg";